import { useErrorToast } from '../lib/useErrorToast';
import { useAnalysesQuery } from '../api/queries/analyses';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

export function Analyses() {
  const analysesQuery = useAnalysesQuery();

  useErrorToast(analysesQuery.error);

  const analyses = analysesQuery.data?.analyses || [];

  return (
    <div className="h-full overflow-scroll p-8 bg-white">
      {analyses.length === 0 ? (
        <div>No analyses found</div>
      ) : (
        <ul className="flex flex-col gap-2">
          {analyses.map((analysis) => (
            <Link
              to={`/a/${analysis.slug}`}
              key={analysis.id}
              className="py-4 bg-white border-b border-black hover:border-orange-2 hover:text-orange-2 px-2"
            >
              <li className="flex justify-between">
                <p>{analysis.name}</p>
                <p>
                  {format(
                    new Date(analysis.startedAt ?? '0'),
                    'MM-dd-yyyy - KK:mmaaa'
                  )}
                </p>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}
